import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationDecimalPipe } from '@sb/library/localization';

@Pipe({
    name: 'lessonCountFromMinutes',
})
export class LessonCountFromMinutesPipe implements PipeTransform {
    constructor(private _LocalizationDecimalPipe: LocalizationDecimalPipe) {}

    transform(minutes: number | undefined, lessonDuration: number | undefined): string {
        if (!lessonDuration) {
            return '';
        }

        if (!minutes) {
            return $localize`:@@TPLessonCountZero:(0 #lessons#)`;
        }

        const lessonCount = minutes / lessonDuration;
        const formattedLessonCount = this._LocalizationDecimalPipe.transform(lessonCount, 0, 2);

        return lessonCount === 1
            ? $localize`:@@TPLessonCountSingular:(${formattedLessonCount} #lesson#)`
            : $localize`:@@TPLessonCountPlural:(${formattedLessonCount} #lessons#)`;
    }
}